export enum UpcomingEventModalModes {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
